<template>
  <div class="uploader-error-container">
    <div class="error-container uk-text-truncate">
      <img :src="warningIcon">
      <span class="error uk-text-middle">{{error.heading}}</span>
    </div>
    <div class="suggestion-container uk-flex uk-flex-middle">
      <span class="suggestion ">{{error.message}}</span>
    </div>
    <div class="guide-link-style">
      <span v-html="error.suggestion"></span>
    </div>
    <div class="code-container">
      {{error.code}}
    </div>
    <div class="button-container">
      <div v-if="error.code === CP_401 || error.code === CP_402">
        <button
          class="uk-button cp-white-button uk-width-1-1 uk-text-bold"
          @click="onSelectFile">
          <span v-if="error.code === CP_401" class="uk-text-capitalize">{{$t('general.select')}}</span>
          <span v-else class="uk-text-capitalize">{{$t('general.change')}}</span>
          <span class="uk-text-lowercase">{{$t('general.file')}}</span>
        </button>
      </div>
      <div v-else>
        <div class="button-left">
          <button v-if="error.code === CP_403"
                  class="uk-button cp-white-button uk-width-1-1 uk-text-bold"
                  @click="onSelectFile">
            <span class="uk-text-capitalize">{{$t('general.select')}}</span>
            <span class="uk-text-lowercase">{{$t('general.file')}}</span>
          </button>
          <button v-else
            class="uk-button cp-blue-border-button uk-width-1-1 uk-text-bold"
            @click="onRetry">
            <span class="uk-text-capitalize">{{$t('general.retry')}}</span>
          </button>
        </div>
        <div class="button-right">
          <button
                  class="uk-button cp-white-button uk-width-1-1 uk-text-bold"
                  @click="onCancel">
            <span class="uk-text-capitalize">{{$t('general.cancel')}}</span>
          </button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as misc from '../../../../enums/misc'
  import iconUtil from '../../../../utils/icon-util'
  import * as errorCode from '../../../../enums/error-codes'
  import * as url from '../../../../enums/static-urls'

  export default {
    name: 'uploader-error',
    data() {
      return {
        warningIcon: iconUtil.resolve(misc.WARNING_ICON_ORANGE),
        CP_401: errorCode.CP_401,
        CP_402: errorCode.CP_402,
        CP_403: errorCode.CP_403,
        CP_404: errorCode.CP_404,
        resourceGuide: url.RESOURCE_GUIDE
      }
    },
    props: ['error'],
    methods: {
      onSelectFile() {
        this.$emit('selectFile')
      },
      onCancel() {
        this.$emit('cancel')
      },
      onRetry() {
        this.$emit('retry')
      },
      redirect(url) {
        window.open(url, '_blank')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../../styles/colours';
  @import '../../../../styles/breakpoints';

  a {
    color: $content-link-blue;
    font-weight: bold;
  }

  .button-container {
    padding-top: 32px;
    padding-bottom: 20px;
    margin-left: 56px;
    margin-right: 56px;
  }

  .button-left {
    float: right;
    width: 49%;
  }

  .button-right {
    float: left;
    width: 49%;
  }

  .code-container {
    padding-left: 56px;
    margin-top: 18px;
    font-size: 14px;
    color: $content-text-light;
  }

  .error {
    padding-left: 14px;
  }

  .error-container {
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 16px;
    font-size: 18px;
    color: $content-text;
  }

  .guide-link-style {
    font-size: 14px;
    padding-left: 56px;
    padding-right: 63px;
    margin-top: 12px;
  }

  .suggestion {
    padding-left: 56px;
  }

  .suggestion-container {
    width: 100%;
    height: 44px;
    background-color: $warning-orange;
    margin-top: 18px;
    font-size: 18px;
    font-weight: bold;
    color: white;
  }

  .uploader-error-container {
    max-width: 600px;
    min-height: 275px;
    border-radius: 8px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    background-color: white;
  }

  .uk-button {
    height: 44px;
    font-size: 18px;
  }

  @media screen and (max-width: $breakpoint-medium) {

    .button-container {
      padding-top: 10px;
      padding-bottom: 10px;
      margin-left: 56px;
      margin-right: 10px;
    }

    .button-left {
      display: block;
      float: none;
      margin-bottom: 10px;
      width: 90%;
    }

    .button-right {
      display: block;
      float: none;
      width: 90%;
      padding-bottom: 10px;
    }

    .error-container {
      font-size: 16px;
    }

    .guide-link-style {
      padding-right: 10px;
    }

    .suggestion-container {
      font-size: 16px;
    }
  }

</style>
